import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "react-lottie";
import "./Login_Modal.css";
// ✅ Renamed this import to 'animationData' to fix the "already declared" error
import animationData from "../../../lottie/account-created-lottie/Account_Created_Lottie.json";

const Login_Modal = ({ showLoginModal, handleLoginModalClose }) => {
  // Lottie configuration options
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="login">
      <div className="Modal-wrapper">
        <Modal show={showLoginModal} onHide={handleLoginModalClose} centered>
          <Modal.Body className="modal-body text-center p-0">
            <div className="login-created-modal">
              <div className="lottie-container">
                <Lottie options={defaultOptions} height={200} width={200} />
              </div>
              <div className="login-text">
                <h3>Logged In Successfully!</h3>
                <p>Let's Begin Your Journey With Oll Type Services</p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </section>
  );
};

export default Login_Modal;
